import { components, lazyComponent } from '@/lib/helpers.js'
import Alpine from 'alpinejs'
import filter from '@/components/filter.js'
import productListing from '@/components/product-listing.js'

//
// Fonts
//
import '@fontsource-variable/albert-sans'

//
// Styles
//
import '../css/style.css'

//
// Initialize components
//
components({
    header: lazyComponent(() => import('@/components/header.js')),
    'embed-video': lazyComponent(() => import('@/components/embed/video.js')),
    'embla-slider': lazyComponent(() => import('@/components/slider.js')),
    'video-player': lazyComponent(() => import('@/components/video-player.js')),
    fancybox: lazyComponent(() => import('@/components/fancybox.js')),
    language: lazyComponent(() => import('@/components/language.js')),
    'secondary-menu-item': lazyComponent(() =>
        import('@/components/secondary-menu-item.js')
    ),
})

//
// Megamenu
//
import './megamenu'
import './menu.js'

//
// Setup Alpine
//
window.Alpine = Alpine

//
// Setup Alpine components
//
Alpine.data('filter', filter)
Alpine.data('productListing', productListing)

//
// Initialize Alpine
//
Alpine.start()
